import React from 'react';
import PropTypes from 'prop-types';
import SearchKishuNameSummary from '../common/SearchKishuNameSummary';
import SelectRateSummary from '../common/SelectRateSummary';
import SelectKikanNewSummary from '../common/SelectKikanNewSummary';
import * as SortMenuInfo from '../../../constants/K007/SortMenuInfo';

/**
 * FilterFormSummary
 */
class FilterFormSummary extends React.Component {

  constructor(props) {
    super(props);
    this.handleFilterFormOpen = this.handleFilterFormOpen.bind(this);
    this.isFilterFormModalOpen = false;
  }

  handleFilterFormOpen() {
    if (this.isFilterFormModalOpen) {
      $('#filter_form').hide();
      this.isFilterFormModalOpen = false;
    } else {
      $('#filter_form').show();
      this.isFilterFormModalOpen = true;
    }
  }

  handlePSRateChange(pskubun, rateId) {
    let sortKey = this.props.data.sortKey;
    let sortIdList = SortMenuInfo.SORT_MENU_SLOT;
    if (rateId <= 2) {
      sortIdList = SortMenuInfo.SORT_MENU_PACHI;
    }
    if (sortIdList.filter(item => item.key === sortKey).length === 0) {
      sortKey = 'out';
    }
    this.props.actions.changePSRate(pskubun, rateId, sortKey);
  }

  render() {
    // 対象レートを作成
    const rateList = [];
    const pachinkoList = this.props.data.itemList.rateList['pachinkoList'];
    const slotList = this.props.data.itemList.rateList['slotList'];
    if (pachinkoList[0].kashidashi_rate != undefined) {
      pachinkoList.forEach((item) => {
        rateList.push({
          pskubun: 0,
          id: item.id,
          display_name: item.kashidashi_rate + 'パチ',
          kashidashi_rate: item.kashidashi_rate
        });
      });
    }
    if (slotList[0].kashidashi_rate != undefined) {
      slotList.forEach((item) => {
        rateList.push({
          pskubun: 1,
          id: item.id,
          display_name: item.kashidashi_rate + 'スロ',
          kashidashi_rate: item.kashidashi_rate
        });
      });
    }

    return (
      <div className="filter_form_summary" id="filter_form_summary">
        <div id="filter_form_area_summary" className="filter_form_area_summary">
          <div className="flex-container gap_default">
            <SearchKishuNameSummary actions={this.props.actions} data={this.props.data} />
            {/* <div id="detail_filter_form_open_btn" className="detail_filter_form_open_btn content_item_border_default" onClick={this.handleFilterFormOpen}>絞込条件</div> */}
          </div>
          <div className="flex-container gap_default">
            <SelectRateSummary actions={this.props.actions} data={this.props.data} isReadOnly={false} rateList={rateList} handlePSRateChange={(pskubun, rateId) => { this.handlePSRateChange(pskubun, rateId); }} />
          </div>
          <div>
            <SelectKikanNewSummary actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />
          </div>
        </div>
      </div>
    );
  }
}

FilterFormSummary.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default FilterFormSummary;
